module.exports = __webpack_public_path__ + "img/7.d80ddc7.png";